
export function findNodeByKeyDFS(key: string, tree: Array<any>) {
    const stack = [...tree];
    while (stack.length > 0) {
        const node = stack.pop();
        if (node?.data?.id == key || node?.rowKey == key) {
            return node;
        }
        if (node?.data?.children && node?.data?.children?.length>0) {
            stack.push(...node?.data?.children);
        }
    }
    return null;
}


export function flattenStatusItemsIterative(treeList: any[], condition: (node: any) => boolean): any[] {
  let result = [];
  let stack = [...treeList];

  while (stack.length > 0) {
    const node = stack.pop();

    if (condition(node)) {
      result.push(node);
    }

    if (node?.data?.children && node?.data?.children?.length > 0) {
      stack.push(...node?.data?.children);
    }
  }

  return result;
}

export function flattenStatusItems(treeList: any[], condition: (node: any) => boolean): any[] {
  let result: any = [];
  const flattenData = flatten(treeList)
  flattenData.forEach((node: any) => {
    if (condition(node)) { result.push(node) }
  })
  return result;
}

export function flatten (arr: any) {
  return arr.reduce((acc: any, item: any) => {
    const children = item?.data?.children ? flatten(item?.data?.children) : [];
    return [...acc, item, ...children];
  }, []);
}

export function listToTree(list: any, parentKey: string) {
    const map = {};
  const tree: Array<any> = [];
  
  // 如果数据都没有id直接返回copy场景
  const isCopy = list.every((i: any) => i.id == null)
  if(isCopy) return list

    // 将列表数据转换为以 id 为 key 的 map
    list.forEach((node: any) => {
        map[node.id] = { ...node, children: node?.children?.length > 0 ? [...node.children]: [] };
    });

    // 构建树形结构
    list.forEach((item: any) => {
    const node = map[item?.id];
    if (item?.[parentKey] && map[item?.[parentKey]]) {
      const existingChild = map[item?.[parentKey]].children.find((child: any) => child.id == node.id);
      if (existingChild) {
        Object.assign(existingChild, node);
      } else {
        map[item?.[parentKey]].children.push(node);
      }
    } else {
      tree.push(node);
    }
    });

    return tree;
}

export const AdapterType = {
  List : 'list',
  Tree : 'tree'
}

export function flattenWithoutChildren(list: any) {
  return list.map(({ children, ...rest }) => ({ ...rest }));
}